<template>
	<div class="container">
		<el-tabs class="tabs" v-model="activeTab" @tab-click="handleClick">
			<el-tab-pane v-if="!isEdit || activeTab=='article'" label="文章" name="article">

			</el-tab-pane>
			<el-tab-pane v-if="!isEdit || activeTab=='video'" label="视频" name="video">

			</el-tab-pane>
			<el-tab-pane v-if="isEdit && activeTab=='trends'" label="动态" name="trends">

			</el-tab-pane>
			<el-tab-pane v-if="isEdit && activeTab=='suggest'" label="优化建议" name="suggest">

			</el-tab-pane>
			<el-tab-pane v-if="isEdit && activeTab=='question'" label="问答" name="question">

			</el-tab-pane>
			<el-tab-pane v-if="isEdit && activeTab=='feedback'" label="Bug反馈" name="feedback">

			</el-tab-pane>

		</el-tabs>
		<div class="create-title">
			<el-input :maxlength="titleMaxLength" show-word-limit type="text" v-model="title" placeholder="请输入标题"/>
		</div>
		<div class="editor-wrap" v-if="activeTab=='article'">
			<Toolbar
				style="border-bottom: 1px solid #EBEBEB"
				:editor="editor"
				:defaultConfig="toolbarConfig"
				:mode="mode"
			/>
			<Editor
				v-model="content"
				:defaultConfig="editorConfig"
				:mode="mode"
				@onCreated="onCreated"
			/>
		</div>
		<textarea v-else-if="activeTab=='video'" v-model="content" class="content" placeholder="视频简介"></textarea>

		<!-- 动态：纯文本内容 -->
		<textarea v-else-if="activeTab=='trends'" v-model="content" class="content" placeholder="分享此刻......"></textarea>
		<!-- 建议 / 问题 -->
		<textarea v-else-if="activeTab=='suggest'||activeTab=='question'" v-model="postDescribe" class="content" :minlength="5" :placeholder="activeTab=='suggest' ? '描述清晰的建议更容易被采纳哦，请尽量详细说明' : '详细描述问题可以更快获得解答'"></textarea>
		<!-- Bug反馈 -->
		<template v-else-if="activeTab=='feedback'">
			<div class="mt-2"><span class="color-red">*</span>操作步骤</div>
			<el-input class="mt-1" type="textarea" :rows="8" :minlength="15" placeholder="请分步骤描述在出现问题前进行了什么操作" v-model="operStep"></el-input>
			<div class="mt-2">预期结果</div>
			<el-input class="mt-1" type="textarea" v-model="expectResult" placeholder="请描述您预期的操作结果"></el-input>
			<div class="mt-2">实际结果</div>
			<el-input class="mt-1" type="textarea" v-model="actualResult" placeholder="请描述您实际的操作结果"></el-input>
			<div class="mt-2">其他信息</div>
			<el-input class="mt-1" type="textarea" v-model="otherResult" placeholder="其他信息在此处备注"></el-input>
		</template>
		<div v-if="activeTab=='article'">
			<div class="mb-1">上传文章封面</div>
			<single-upload class="width-full" v-model="coverUrl" @getImgData="uploadSuccessCover($event)"></single-upload>
		</div>
		<div v-if="activeTab=='video'">
			<UploadImg @uploadDelete="uploadDelete" @uploadSuccess="uploadSuccess"/>
		</div>
		<div class="video-wrap" v-if="activeTab=='video'">
			<UploadVideo @uploadDelete="uploadDeleteVideo" @uploadSuccess="uploadSuccessVideo"/>
		</div>
		<div v-if="activeTab=='trends'||activeTab=='suggest'||activeTab=='question'||activeTab=='feedback'">
			<UploadImg @uploadDelete="uploadDelete" @uploadSuccess="uploadSuccess"/>
		</div>
		<div class="select">
			<el-form label-position="top">
				<!-- <el-form-item label="选择圈子分类">
				    <el-select filterable @change="changeCircleClassify" v-model="circleCategoryId" placeholder="请搜索或选择圈子分类">
				      <el-option v-for="(item,index) in circleClassifyList" :key="index" :label="item.categoryName" :value="item.id"></el-option>
				    </el-select>
				</el-form-item>
				<el-form-item label="选择圈子">
					<el-cascader
						placeholder="请搜索或选择圈子"
						v-model="circleId"
						:options="circleList"
						filterable>
					</el-cascader>
				     <el-select filterable @change="changeCircle" v-model="circleId" placeholder="请搜索或选择圈子">
				      <el-option v-for="(item,index) in circleList" :key="index" :label="item.circleName" :value="item.id"></el-option>
				    </el-select> -->
				<!-- </el-form-item> -->
				<!-- <el-form-item label="帖子类型">
				    <el-select filterable  v-model="categoryId" placeholder="请搜索或选择类型">
				      <el-option v-for="(item,index) in postCategoryList" :key="index" :label="item.categoryName" :value="item.id"></el-option>
				    </el-select>
				</el-form-item> -->
				<el-form-item v-if="activeTab=='article'||activeTab=='video'||activeTab=='trends'" label="选择话题">
				    <el-select filterable @change="changeTalkPost"  v-model="talkId" placeholder="请搜索或选择话题">
				      <el-option v-for="(item,index) in talkList" :key="index" :label="item.categoryName" :value="item.id"></el-option>
				    </el-select>
				</el-form-item>
				<el-form-item label="选择圈子" class="ml-2">
					<el-cascader
						:options="options"
						:props="cascaderProps"
						popper-class="circle-cascader-popper"
						v-model="selectedOptions"
						@change="handleChange">
					</el-cascader>
				</el-form-item>
			</el-form>
			<div class="btns">
				<a v-if="artcleId&&activeTab=='article'" @click="saveModifyPublic" href="javascript:;">保存草稿</a>
				<a v-if="!artcleId&&activeTab=='article'" @click="savePublic" href="javascript:;">保存草稿</a>
				<a v-if="activeTab=='article'" href="javascript:;" @click="viewPublic">在线预览</a>
				<a v-if="artcleId" @click="toModify" href="javascript:;" class="active">发布</a>
				<a v-else @click="toPublic" href="javascript:;" class="active">发布</a>
			</div>
		</div>
	</div>
</template>

<script>
	import '@wangeditor/editor/dist/css/style.css'
	import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
	import { post, config, ajaxParam } from '@/units/request.js'
	import UploadImg from '@/components/upload/videoCover'
	import UploadVideo from '@/components/upload/video'
	import postCateModules from '@/modules/postCategory.js'
	import qs from 'qs'
	import { Cascader } from 'element-ui';
	import singleUpload from '@/components/upload/singleUpload'

	export default {
		name: 'publicIndex',
		components: {
			Editor,
			singleUpload,
			Toolbar,
			UploadImg,
			UploadVideo,
			'el-cascader': Cascader
		},
		mixins:[
			postCateModules
		],
		data(){
			const that = this
				// 自定义校验链接
      function customCheckLinkFn(text, url) {                                              // JS 语法

				if (!url) {
					return
				}
				if (url.indexOf('http') !== 0) {
					that.$message.warning('链接必须以 http/https 开头')
					return
				}
				return true

				// 返回值有三种选择：
				// 1. 返回 true ，说明检查通过，编辑器将正常插入链接
				// 2. 返回一个字符串，说明检查未通过，编辑器会阻止插入。会 alert 出错误信息（即返回的字符串）
				// 3. 返回 undefined（即没有任何返回），说明检查未通过，编辑器会阻止插入。但不会提示任何信息
			}

			// 自定义转换链接 url
			function customParseLinkUrl(url) {

			if (url.indexOf('http') !== 0) {
				return `http://${url}`
			}
			return url
			}
			return{
				newArticleId:'',
				activeTab: 'article',
				title: '',
				titleLength: 30,
				userId: '',
				picUrls: '',
				coverUrl: '', //视频封面
				postType: 0, //0文字动态1图片动态2视频动态
				categoryId: '',
				content: '',
				postDescribe: '',
				operStep: '',
				expectResult: '',
				actualResult: '',
				otherResult: '',
				circleId: '',
				selectPost: '',
				postStatus: 1, // 0草稿，1发布
				circleList: [],
				artcleId: '',
				circleCategoryId:'',
				circleClassifyList: [],
				talkId:'',
				talkList: [],
				editor: null,
				html: '',
				toolbarConfig: {
					excludeKeys: [
						"bulletedList", // 无序列表
 						"numberedList", // 有序列表

						// 'insertVideo'
					]
				},
				editorConfig: {
				placeholder: '请输入内容...' ,
				autoFocus: false,
				autoHeightEnabled: false,
				MENU_CONF: {
					uploadImage: {
						server: config.baseUrl + "v1/upload/editorUpload",
						fieldName: "file"
					},
					insertLink:{
						checkLink: customCheckLinkFn, // 也支持 async 函数
  							parseLinkUrl: customParseLinkUrl, // 也支持 async 函数
					},
					editLink:{
						checkLink: customCheckLinkFn, // 也支持 async 函数
  							parseLinkUrl: customParseLinkUrl, // 也支持 async 函数
					}
				}
			},
				mode: 'simple', // or 'simple'
				uploadFileUrl: [],
				options: [],
        selectedOptions: []
			}
		},
		computed: {
			isEdit() {
				return this.$route.query.mode === 'edit'
			},
			titleMaxLength() {
				// 仅文章/视频限制30字，其他类型不限
				return (this.activeTab=='article'||this.activeTab=='video') ? 30 : null
			},
			cascaderProps() {
				const isThreeLevel = this.activeTab=='article'||this.activeTab=='video'||this.activeTab=='trends'
				return {
					value: 'id',
					label: 'value',
					checkStrictly: isThreeLevel,
					expandTrigger: 'hover'
				}
			}
		},
		watch: {
			title(newVal){
				console.log(newVal)
				this.titleLength = 30-newVal.length
				if(this.titleLength<=0) {
					this.titleLength = 0
				}
			},
			uploadFileUrl(newVal, oldVal){
				console.log('变')
				if(newVal.length>0){
					this.picUrls = newVal.join(',')
					console.log(this.picUrls)
				}
			},
			async $route(to, from) {
				this.activeTab = to.query.type || 'article'
				if (to.query.mode === 'edit' && to.query.id) {
					// 编辑模式：加载帖子数据
					if (to.query.id !== this.artcleId) {
						this.artcleId = to.query.id
						this.resetForm()
						await this.getTalkList()
						this.getDetailById()
					}
				} else if (from.query.mode === 'edit' && !to.query.mode) {
					// 从编辑模式切换到新建模式：清除编辑状态
					this.artcleId = ''
					this.resetForm()
					this.getCircleCategory()
				}
			}
		},
		beforeRouteLeave(to, from, next) {
			// 离开编辑页时清除编辑状态，避免数据残留
			this.resetForm()
			this.artcleId = ''
			next()
		},
		async created(){
			this.userId = localStorage.getItem('userId')||''
			this.activeTab = this.$route.query.type || 'article'
			// 兼容数字类型参数（publicManage 传来的是 postType 数字）
			const typeMap = { '0': 'article', '1': 'trends', '2': 'video', '3': 'suggest', '4': 'question', '5': 'feedback' }
			this.activeTab = typeMap[this.activeTab] || this.activeTab
			if(this.activeTab=='article') {
				this.postType = 0
			} else if(this.activeTab=='video') {
				this.postType = 2
			} else if(this.activeTab=='trends') {
				this.postType = 1
			} else if(this.activeTab=='suggest') {
				this.postType = 3
			} else if(this.activeTab=='question') {
				this.postType = 4
			} else if(this.activeTab=='feedback') {
				this.postType = 5
			}
			await this.getTalkList()
			if(this.$route.query.id){
				this.artcleId = this.$route.query.id
				this.getDetailById()
			} else {
				this.getCircleCategory()
			}
		},
		methods: {
			// 选择圈子
			handleChange(e){
				const len = this.selectedOptions.length
				// 三级级联：[分类ID, 圈子ID, 标签ID]，标签可选
				if (len >= 3) {
					this.circleId = this.selectedOptions[1]
					this.categoryId = this.selectedOptions[2]
				} else if (len === 2) {
					this.circleId = this.selectedOptions[1]
					this.categoryId = null
				} else {
					this.circleId = null
					this.categoryId = null
				}
			},
			findCascaderPath(options, circleId, categoryId){
				// 在树中找到匹配 circleId 的路径，categoryId 可选
				function search(nodes, path, targetCircleId, targetCategoryId){
					for (const node of nodes) {
						const currentPath = path.concat([node.id])
						// 匹配圈子：先检查当前节点是否为 targetCircleId（不依赖 children 是否存在）
						if (node.id == targetCircleId) {
							if (targetCategoryId && node.children && node.children.length > 0) {
								for (const child of node.children) {
									if (child.id == targetCategoryId) {
										return currentPath.concat([child.id])
									}
								}
							}
							return currentPath
						}
						// 递归搜索子节点
						if (node.children && node.children.length > 0) {
							const result = search(node.children, currentPath, targetCircleId, targetCategoryId)
							if (result) return result
						}
					}
					return null
				}
				return search(options, [], circleId, categoryId) || []
			},
			async getCircleCategory(){
				let param = {
					userId: this.userId
				}
				ajaxParam(param)
				const isTwoLevel = this.activeTab=='suggest'||this.activeTab=='question'||this.activeTab=='feedback'
				const api = isTwoLevel ? 'v1/circle/joinCircleOtherTwoLevel' : 'v1/circle/joinCircleThreeLevel'
				const res = await post(api, qs.stringify(param))
				if(res.data.code==200){
					this.options = res.data.list
				} else {
					this.$message.error(res.data.msg)
				}
			},
			//根据id获取详情，修改时用
			async getDetailById(){
				let param = {
					postId: this.artcleId,
					userId: this.userId
				}
				ajaxParam(param)
				const res = await post('v1/circle/postInfo', qs.stringify(param))
				if(res.data.code==200){
					let entity = res.data.entity
					this.title = entity.postName
					this.content = entity.content
					this.postDescribe = entity.postDescribe || ''
					this.operStep = entity.operStep || ''
					this.expectResult = entity.expectResult || ''
					this.actualResult = entity.actualResult || ''
					this.otherResult = entity.otherResult || ''
					this.circleCategoryId= entity.circleCategoryId
					this.circleId = entity.circleId
					this.talkId = entity.talkId
					this.categoryId = entity.categoryId
					await this.getCircleCategory()
					await this.$nextTick()
					const path = this.findCascaderPath(this.options, entity.circleId, entity.categoryId)
					this.selectedOptions = path
					this.getPostCategory()
				} else {
					this.$message.error(res.data.msg)
				}
			},
			//编辑帖子，修改时用
			async toModify(){
				let param = {
					id: this.artcleId,
					userId: this.userId,
					circleId: this.circleId,
					talkId: this.talkId,
					postName: this.title,
					picUrls: this.picUrls,
					content: this.content,
					postDescribe: this.postDescribe,
					operStep: this.operStep,
					expectResult: this.expectResult,
					actualResult: this.actualResult,
					otherResult: this.otherResult,
					postType: this.postType,
					categoryId: this.categoryId,
					postStatus: this.postStatus
				}
				ajaxParam(param)
				const res = await post('v1/circle/updatePost', qs.stringify(param))
				if(res.data.code==200){
					this.$message.success(res.data.msg||'操作成功!')
					// this.$message.success('修改发布成功!')
					this.$router.push({
						path: '/publicManage'
					})
				} else {
					this.$message.error(res.data.msg)
				}
			},
			//保存草稿修改
			async saveModifyPublic(){
				this.postStatus = 0
				let param = {
					id: this.artcleId,
					userId: this.userId,
					circleId: this.circleId,
					talkId: this.talkId,
					postName: this.title,
					picUrls: this.picUrls,
					content: this.content,
					postDescribe: this.postDescribe,
					operStep: this.operStep,
					expectResult: this.expectResult,
					actualResult: this.actualResult,
					otherResult: this.otherResult,
					postType: this.postType,
					categoryId: this.categoryId,
					postStatus: this.postStatus
				}
				ajaxParam(param)
				const res = await post('v1/circle/updatePost', qs.stringify(param))
				if(res.data.code==200){
					this.$message.success(res.data.msg||'操作成功!')
					// this.$message.success('修改草稿成功!')
					this.$router.push({
						path: '/publicManage'
					})
				} else {
					this.$message.error(res.data.msg)
				}
			},
			uploadSuccessVideo(e){
				console.log(e)
				console.log(e.videoUrl)
				this.picUrls = e.videoUrl
				console.log(this.picUrls)
			},
			uploadDeleteVideo(e){

			},
			uploadSuccessCover(e){
				this.coverUrl = e
			},
			uploadSuccess(e){
				console.log('success')
				console.log(e.uploadFileList)
				this.coverUrl = e.uploadFileList[0]
			},
			uploadDelete(e){
				console.log('delete')
				console.log(e.uploadFileList)
				this.coverUrl = ''
			},
			changeTalkPost(e){
				this.talkId = e
				console.log(e)
			},
			//获取加入圈子话题
			async getTalkList(){
				let param = {}
				ajaxParam(param)
				const res = await post('v1/circle/circlePostTalk', qs.stringify(param))
				if(res.data.code==200){
					this.talkList = res.data.list
				} else {
					this.$message.error(res.data.msg)
				}
			},
			//保存草稿
			savePublic(){
				this.postStatus = 0
				if(!this.title&&(!this.content||this.content=='<p><br></p>')){
					this.$message.error('请至少填写一处才能保存')
					return
				}
				this.public()
			},
			//在线预览
			async viewPublic(){
				if(!this.title&&(!this.content||this.content=='<p><br></p>')){
					this.$message.error('请至少填写一处才能保存')
					return
				}
				this.postStatus = 0

					let param = {
						postName: this.title,
						picUrls: this.picUrls,
						content: this.content
					}
					if(this.talkId){
						const talkItem = this.talkList.filter(item=>{return item.id==this.talkId})
						if(talkItem.length>0){
							const talkName = talkItem[0].categoryName
							param.talkName = talkName
						}
					}
					localStorage.setItem('previewInfo',JSON.stringify(param))
					window.open('/detail?id=')

			},
			toPublic(){
				this.postStatus = 1
				if((this.activeTab=='article'||this.activeTab=='video'||this.activeTab=='feedback') && !this.title) {
					this.$message.error('请输入标题')
					return
				}
				if((this.activeTab=='article'||this.activeTab=='video'||this.activeTab=='trends') && (!this.content||this.content=='<p><br></p>')) {
					this.$message.error('请输入发布内容')
					return
				}
				if(!this.circleId) {
					this.$message.error('请选择圈子')
					return
				}
				this.public()
			},
			//发布
			async public(){
				let param = {
					userId: this.userId,
					talkId: this.talkId,
					postName: this.title,
					picUrls: this.picUrls,
					coverUrl: this.coverUrl,
					content: this.content,
					postDescribe: this.postDescribe,
					operStep: this.operStep,
					expectResult: this.expectResult,
					actualResult: this.actualResult,
					otherResult: this.otherResult,
					postType: this.postType,
					categoryId: this.categoryId,
					circleId: this.circleId,
					postStatus: this.postStatus
				}
				const isUpdate = this.postStatus===0 && this.newArticleId
				if(isUpdate){
					param.id = this.newArticleId
				}
				console.log('发布编辑', param)
				ajaxParam(param)
				const url = isUpdate ? 'v1/circle/updatePost' : 'v1/circle/addPost'
				const res = await post(url, qs.stringify(param))
				if(res.data.code==200){
					this.$message.success(res.data.msg||'操作成功!')
					if(this.postStatus==1){
						this.$router.push({
							path: '/publicManage'
						})
					}
					if(this.postStatus===0){
						this.newArticleId = res.data.entity.id
					}
				} else {
					this.$message.error(res.data.msg)
				}
			},
			onCreated(editor) {
				this.editor = Object.seal(editor) // 一定要用 Object.seal() ，否则会报错
			},
			//上传视频前验证
			beforeUpload(file){
				const fileSuffix = file.name.substring(file.name.lastIndexOf(".") + 1)
				const whiteList = ['mp4', 'avi']
				if (whiteList.indexOf(fileSuffix) == -1) {
					this.$message.error("请上传正确的视频格式")
					return false
				}
			},
			//上传附件成功
			handleSuccess(res){
				console.log(res)
				window.alert('--------')
			},
			resetForm(){
				this.title = ''
				this.content = ''
				this.postDescribe = ''
				this.operStep = ''
				this.expectResult = ''
				this.actualResult = ''
				this.otherResult = ''

				this.circleCategoryId = ''
				this.circleId = ''
				this.categoryId = ''
				this.talkId = ''
				this.selectedOptions = []

				this.picUrls = ''
				this.coverUrl = ''
			},
			handleClick(tab,e){
				this.coverUrl = ''
				this.activeTab = tab.name
				this.content= ''
				this.newArticleId = ''
				if(tab.name=='video'){
					this.postType = 2
				} else if(tab.name=='trends'){
					this.postType = 1
				} else if(tab.name=='suggest'){
					this.postType = 3
				} else if(tab.name=='question'){
					this.postType = 4
				} else if(tab.name=='feedback'){
					this.postType = 5
				} else {
					this.postType = 0
				}
				this.resetForm()
			}
		}
	}
</script>

<style lang="less" scoped>
::v-deep .el-form--label-top .el-form-item__label {
	padding: 0;
}

.container {
	position: relative;
	background: #fff;
	padding: 20px 16px;

	.create-title {
		display: flex;
		align-items: center;
		margin: 22px 0 15px;

		input {
			width: 100%;
			height: 22px;
			padding: 5px 10px;
			border: 1px solid #EBEBEB;
		}

		span {
			margin-left: 10px;
			font-size: 12px;
			color: #4a4a4a;
		}
	}

	.editor-wrap {
		margin-bottom: 20px;
		border: 1px solid #EBEBEB;
		min-width: 0;

		/deep/ .w-e-text-container {
			max-height: 500px !important;
			overflow-y: auto !important;
			min-height: 200px;
		}

		/deep/ .w-e-text {
			min-height: 200px;
			padding: 10px 15px;
		}

		/deep/ .w-e-text table {
			display: block;
			width: 100%;
			max-width: 100%;
			overflow-x: auto;
			border-collapse: collapse;
			margin: 10px 0;

			th, td {
				border: 1px solid #ddd;
				padding: 8px;
				text-align: left;
			}

			th {
				background: #f5f5f5;
			}
		}
	}

	/deep/ .w-e-full-screen-container {
		z-index: 9999 !important;
		position: fixed !important;
		top: 0 !important;
		left: 0 !important;
		right: 0 !important;
		bottom: 0 !important;
		width: 100vw !important;
		height: 100vh !important;
		background: #fff !important;

		.w-e-text-container {
			max-height: none !important;
			height: calc(100vh - 40px) !important;
			overflow-y: auto !important;
		}

		.w-e-toolbar {
			position: sticky;
			top: 0;
			z-index: 10;
			background: #fff;
		}
	}

	.content {
		width: 60%;
		height: 160px;
		margin-bottom: 15px;
		padding: 10px;
		border-color: #DBDCDC;
		box-sizing: border-box;
		border-radius: 4px;
		overflow: auto;
	}

	.select {
		display: flex;
		flex-direction: column;

		.el-form {
			display: flex;
			justify-content: space-between;

			.el-form-item {
				flex: 1;

				/deep/ .el-form-item__content {
					line-height: 30px;
				}

				/deep/ .el-input__inner {
					height: 30px;
					line-height: 30px;
				}

				/deep/ .el-input__icon {
					line-height: 30px;
				}

				:deep .el-cascader {
					line-height: 30px;
				}
			}
		}
	}

	.btns {
		display: flex;
		justify-content: flex-end;
		margin-top: 20px;

		a {
			display: block;
			width: 88px;
			height: 34px;
			margin-left: 15px;
			background: rgba(50, 50, 50, .1);
			border-radius: 16px;
			line-height: 34px;
			text-align: center;
		}

		a:hover, a.active {
			background: #DD0515;
			color: #fff;
		}
	}

	.video-wrap {
		margin-bottom: 20px;
	}

	.empty {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		width: 260px;
		margin: 60px auto;

		img {
			width: 260px;
			height: 230px;
		}

		span {
			padding: 20px 0 30px;
			color: var(--color-text-opacity);
		}

		.public-btn {
			display: block;
			width: 88px;
			height: 34px;
			background: #DD0515;
			border-radius: 16px;
			line-height: 34px;
			text-align: center;
			color: #fff;
		}
	}
}

:deep(.w-e-text-container [data-slate-editor]) {
	word-break: break-all !important;
}

:deep(.w-e-text),
:deep(.w-e-text *) {
	max-width: 100%;
	word-break: break-word;
	overflow-wrap: anywhere;
	white-space: pre-wrap;
}
</style>

<style lang="less">
/* 圈子级联选择器交互优化 */
.circle-cascader-popper .el-cascader-node {
	position: relative;
}
/* 取消 radio 自身定位，让 ::after 遮罩层相对节点定位，实现点击文字也可选中 */
.circle-cascader-popper .el-cascader-node .el-radio {
	position: static !important;
}
/* 点击节点任意位置（含文字）等同点击单选按钮，圆圈和文字保持原位 */
.circle-cascader-popper .el-cascader-node .el-radio::after {
	content: '';
	position: absolute;
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
	z-index: 10;
	cursor: pointer;
}
/* 选中路径上的父级节点高亮，表示已包含在选中路径中 */
.circle-cascader-popper .el-cascader-node.in-checked-path:not(.is-active) {
	color: #DD0515;
	font-weight: 600;
}
/* 第一层（圈子分类）隐藏单选框，仅展开不选中 */
.circle-cascader-popper .el-cascader-menu:first-child .el-cascader-node .el-radio {
	display: none;
}
</style>
